/**
 * @file useCustomersRegistry.ts
 * @description Данные реестра клиентов (phase19.31): страница клиентов по
 * фильтрам из адреса, постранично (`offset/limit`). Устройство — общий
 * `useUrlRegistry` (как у реестра сделок).
 */

import { useUrlRegistry, type UrlRegistrySpec, type UrlRegistryState } from "../../crm/useUrlRegistry";
import { customers, type CustomerDto } from "../../../lib/api-customers";
import {
  parseCustomersQuery,
  resetCustomersQuery,
  toListCustomersParams,
  writeCustomersQuery,
  type CustomersRegistryQuery,
} from "../../../lib/crm-customers-query";

const loadCustomers = (query: CustomersRegistryQuery) => customers.list(toListCustomersParams(query));

const SPEC: UrlRegistrySpec<CustomersRegistryQuery, CustomerDto> = {
  parse: parseCustomersQuery,
  write: writeCustomersQuery,
  load: loadCustomers,
  reset: resetCustomersQuery,
  errorText: {
    empty: "Не удалось загрузить клиентов. Проверьте связь и попробуйте ещё раз",
    stale: "Не удалось обновить список, данные могут быть устаревшими",
  },
};

export function useCustomersRegistry(): UrlRegistryState<CustomersRegistryQuery, CustomerDto> {
  return useUrlRegistry(SPEC);
}
